import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AuthPageShell from "../components/AuthPageShell";
import TotpForm from "../components/TotpForm";
import { authTextButtonStyle } from "../theme/authTextButtonStyle";

const TotpPage = () => {
  const { t } = useTranslation("auth");
  const location = useLocation();
  const email = location.state?.email || "your@example.com";

  return (
    <AuthPageShell
      title={t("totpPage.title")}
      subtitle={t("totpPage.subtitle")}
    >
      <TotpForm verifyAction="loginSuccessful" />

      <div className="mt-6 text-center">
        <Link
          to="/verify-email-otp"
          state={{ email, autoSendOtp: true }}
          className="text-primary transition"
          style={authTextButtonStyle}
        >
          {t("totpPage.tryAnotherMethod")}
        </Link>
      </div>
    </AuthPageShell>
  );
};

export default TotpPage;
